import UIFetchService from '../Service/UIFetchService';

import moment from 'moment';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { Divider, Button, DatePicker, Row, Col, message, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import React from 'react';

class AlertView extends React.Component {

    constructor() {
        super();
        this.state = {
            dailyFormTestDate: moment().subtract(1, 'days'),
            dailyReferalTestDate: moment().subtract(1, 'days'),
            weeklyFormTestDate: moment().subtract(1, 'weeks'),
            monthlyFormTestDate: moment().subtract(1, 'months')
        };
    }

    async componentDidMount() {
        let script = await UIFetchService.get('/api/v1/period_form_alert/scripts/daily_form');
        //this.setState({ script });

        let monacoDomNode = document.getElementById('site-daily-form-script');
        let instance = monaco.editor.create(monacoDomNode, {
            value: script.script,
            theme: 'vs-light',
            fontSize: 11,
            language: 'java',
            automaticLayout: true
        });
        this.dailyFormEditor = instance;

        script = await UIFetchService.get('/api/v1/period_form_alert/scripts/weekly_form');
        monacoDomNode = document.getElementById('site-weekly-form-script');
        instance = monaco.editor.create(monacoDomNode, {
            value: script.script,
            theme: 'vs-light',
            fontSize: 11,
            language: 'java',
            automaticLayout: true
        });
        this.weeklyFormEditor = instance;

        script = await UIFetchService.get('/api/v1/period_form_alert/scripts/monthly_form');
        monacoDomNode = document.getElementById('site-monthly-form-script');
        instance = monaco.editor.create(monacoDomNode, {
            value: script.script,
            theme: 'vs-light',
            fontSize: 11,
            language: 'java',
            automaticLayout: true
        });
        this.monthlyFormEditor = instance;
    }

    componentWillUnmount() {
        this.dailyFormEditor?.dispose();
        this.weeklyFormEditor?.dispose();
        this.monthlyFormEditor?.dispose();
    }

    render() {
        return <>
            <Row>
                <Col >
                    <h2>日报预警脚本</h2>
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <div id="site-daily-form-script" style={{ textAlign: 'left', height: 400 }}></div>
                </Col>
            </Row>
            <div style={{ height: 10 }}></div>
            <Row>
                <Col span={2} style={{ alignSelf: 'center' }}>
                    {this.state.dailyFormTestPending && <LoadingOutlined />}
                    <span>选择日期：</span>
                </Col>
                <Col span={4}>
                    <DatePicker
                        disabled={this.state.dailyFormTestPending}
                        defaultValue={this.state.dailyFormTestDate}
                        value={this.state.dailyFormTestDate}
                        onChange={(date) => this.setState({ dailyFormTestDate: date })} />
                </Col>
                <Col span={2}>
                    <Button disabled={this.state.dailyFormTestPending} onClick={this.testDailyFormV2.bind(this)}>测试日报v2</Button>
                </Col>
                <Col flex="auto" />
                <Col>
                    <Button type="primary" onClick={() => this.saveScript('daily')} >保存</Button>
                </Col>
            </Row>
            <Divider />
            <Row>
                <Col >
                    <h2>周报预警脚本</h2>
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <div id="site-weekly-form-script" style={{ textAlign: 'left', height: 400 }}></div>
                </Col>
            </Row>
            <div style={{ height: 10 }}></div>
            <Row>
                <Col span={2} style={{ alignSelf: 'center' }}>
                    {this.state.weeklyFormTestPending && <LoadingOutlined />}
                    <span>选择周：</span>
                </Col>
                <Col span={4}>
                    <DatePicker
                        disabled={this.state.weeklyFormTestPending}
                        defaultValue={this.state.weeklyFormTestDate}
                        value={this.state.weeklyFormTestDate}
                        picker="week"
                        onChange={(date, dateString) => {
                            //console.log(date.format('YYYY-MM-DD'), dateString);
                            this.setState({ weeklyFormTestDate: date });
                        }} />
                </Col>
                <Col span={2}>
                    <Button disabled={this.state.weeklyFormTestPending} onClick={this.testWeeklyForm.bind(this)}>测试周报</Button>
                </Col>
                <Col flex="auto" />
                <Col>
                    <Button type="primary" onClick={() => this.saveScript('weekly')} >保存</Button>
                </Col>
            </Row>
            <Divider />
            <Row>
                <Col >
                    <h2>月报预警脚本</h2>
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <div id="site-monthly-form-script" style={{ textAlign: 'left', height: 400 }}></div>
                </Col>
            </Row>
            <div style={{ height: 10 }}></div>
            <Row>
                <Col span={2} style={{ alignSelf: 'center' }}>
                    {this.state.monthlyFormTestPending && <LoadingOutlined />}
                    <span>选择月：</span>
                </Col>
                <Col span={2}>
                    <DatePicker
                        disabled={this.state.monthlyFormTestPending}
                        defaultValue={this.state.monthlyFormTestDate}
                        value={this.state.monthlyFormTestDate}
                        picker="month"
                        onChange={(date, dateString) => {
                            console.log(date.format('YYYY-MM-DD'), dateString);
                            this.setState({ monthlyFormTestDate: date });
                        }} />
                </Col>
                <Col span={2}>
                    <Button disabled={this.state.monthlyFormTestPending} onClick={this.testMonthlyForm.bind(this)}>测试月报</Button>
                </Col>
                <Col flex="auto" />
                <Col>
                    <Button type="primary" onClick={() => this.saveScript('monthly')} >保存</Button>
                </Col>
            </Row>
            <Divider />
            <Row>
                <Col >
                    <h2>导流日报</h2>
                </Col>
            </Row>
            <Row>
                <Col span={2} style={{ alignSelf: 'center' }}>
                    {this.state.dailyReferalTestPending && <LoadingOutlined />}
                    <span>选择日期：</span>
                </Col>
                <Col span={2}>
                    <DatePicker
                        disabled={this.state.dailyReferalTestPending}
                        defaultValue={this.state.dailyReferalTestDate}
                        value={this.state.dailyReferalTestDate}
                        onChange={(date) => this.setState({ dailyReferalTestDate: date })} />
                </Col>
                <Col span={2}>
                    <Button disabled={this.state.dailyReferalTestPending} onClick={this.testDailyReferal.bind(this)}>测试日报</Button>
                </Col>
            </Row>
        </>
    }

    saveScript(which) {
        switch (which) {
            case 'daily':
            case 'weekly':
            case 'monthly': {
                const script = this[`${which}FormEditor`].getValue();
                UIFetchService.method('PUT', `/api/v1/period_form_alert/scripts/${which}_form`, { script })
                    .then(() => {
                        message.success('脚本保存成功。');
                    });
            } break;
            default:
                break;
        }
    }

    testDailyForm() {
        // /tests/daily_form/{day}
        const day = this.state.dailyFormTestDate.format('YYYY-MM-DD');
        this.setState({ dailyFormTestPending: true });
        notification.info({
            message: '日报消息生成中...',
            description: '请耐心等待；可能需要1～5分钟。'
        });
        UIFetchService.post(`/api/v1/period_form_alert/tests/daily_form/${day}`, {})
            .then(() => message.success('企业微信消息发送成功。'))
            .finally(() => this.setState({ dailyFormTestPending: false }));
    }

    testDailyReferal() {
        const day = this.state.dailyReferalTestDate.format('YYYY-MM-DD');
        this.setState({ dailyReferalTestPending: true });
        notification.info({
            message: '日报消息生成中...',
            description: '请耐心等待；可能需要1～5分钟。'
        });
        UIFetchService.post(`/api/v1/period_form_alert/tests/daily_referral_v2/${day}`, {})
            .then(() => message.success('企业微信消息发送成功。'))
            .finally(() => this.setState({ dailyReferalTestPending: false }));
    }

    testDailyFormV2() {
        const day = this.state.dailyFormTestDate.format('YYYY-MM-DD');
        this.setState({ dailyFormTestPending: true });
        notification.info({
            message: '日报消息生成中...',
            description: '请耐心等待；可能需要1～5分钟。'
        });
        UIFetchService.post(`/api/v1/period_form_alert/tests/daily_form_v2/${day}`, {})
            .then(() => message.success('企业微信消息发送成功。'))
            .finally(() => this.setState({ dailyFormTestPending: false }));
    }

    testWeeklyForm() {
        const day = this.state.weeklyFormTestDate.format('YYYY-MM-DD');
        this.setState({ weeklyFormTestPending: true });
        notification.info({
            message: '周报消息生成中...',
            description: '请耐心等待；可能需要1～5分钟。'
        });
        UIFetchService.post(`/api/v1/period_form_alert/tests/weekly_form/${day}`, {})
            .then(() => message.success('企业微信消息发送成功。'))
            .finally(() => this.setState({ weeklyFormTestPending: false }));
    }

    testMonthlyForm() {
        const day = this.state.monthlyFormTestDate.format('YYYY-MM-DD');
        this.setState({ monthlyFormTestPending: true });
        notification.info({
            message: '月报消息生成中...',
            description: '请耐心等待；可能需要1～5分钟。'
        });
        UIFetchService.post(`/api/v1/period_form_alert/tests/monthly_form/${day}`, {})
            .then(() => message.success('企业微信消息发送成功。'))
            .finally(() => this.setState({ monthlyFormTestPending: false }));
    }
}

export default AlertView;